import * as React from 'react';
import { createSelector, ReactStore } from '@base-ui-components/utils/store';
const selectors = {
  open: createSelector(state => state.open),
  modal: createSelector(state => state.modal),
  nested: createSelector(state => state.nested),
  nestedOpenDialogCount: createSelector(state => state.nestedOpenDialogCount),
  dismissible: createSelector(state => state.dismissible),
  openMethod: createSelector(state => state.openMethod),
  descriptionElementId: createSelector(state => state.descriptionElementId),
  titleElementId: createSelector(state => state.titleElementId),
  mounted: createSelector(state => state.mounted),
  transitionStatus: createSelector(state => state.transitionStatus),
  triggerProps: createSelector(state => state.triggerProps),
  popupProps: createSelector(state => state.popupProps),
  floatingRootContext: createSelector(state => state.floatingRootContext),
  popupElement: createSelector(state => state.popupElement),
  triggerElement: createSelector(state => state.triggerElement)
};
export class DialogStore extends ReactStore {
  static create(initialState) {
    const context = {
      popupRef: /*#__PURE__*/React.createRef(),
      backdropRef: /*#__PURE__*/React.createRef(),
      internalBackdropRef: /*#__PURE__*/React.createRef()
    };
    return new DialogStore(initialState, context, selectors);
  }
  setOpen = (nextOpen, eventDetails) => {
    this.context.openChange?.(nextOpen, eventDetails);
    if (eventDetails.isCanceled) {
      return;
    }
    const details = {
      open: nextOpen,
      nativeEvent: eventDetails.event,
      reason: eventDetails.reason,
      nested: this.state.nested
    };
    this.state.floatingRootContext.events?.emit('openchange', details);
    this.set('open', nextOpen);
  };
}